module.exports = __webpack_public_path__ + "static/media/grey-star.f23f9a6b.svg";